var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInboxCount = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move_to_inbox",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "move_to_inbox_FILL0_wght300_GRAD-25_opsz20",
    d: "M177.736-783.193v-2.56a.523.523,0,0,1,.159-.381.516.516,0,0,1,.38-.16.532.532,0,0,1,.385.16.516.516,0,0,1,.163.381v2.56l1.167-1.167a.616.616,0,0,1,.172-.116.586.586,0,0,1,.206-.058.427.427,0,0,1,.208.041.594.594,0,0,1,.18.12.5.5,0,0,1,.185.394.57.57,0,0,1-.182.391l-1.986,1.981a.814.814,0,0,1-.225.163.6.6,0,0,1-.26.056.616.616,0,0,1-.262-.056.7.7,0,0,1-.214-.154l-2.01-2.006a.6.6,0,0,1-.1-.177.569.569,0,0,1-.036-.2.561.561,0,0,1,.048-.218.542.542,0,0,1,.136-.194.475.475,0,0,1,.367-.148.532.532,0,0,1,.365.175Zm-5.1,8.464a1.311,1.311,0,0,1-.958-.406,1.311,1.311,0,0,1-.406-.958v-11.271a1.3,1.3,0,0,1,.406-.966,1.323,1.323,0,0,1,.958-.4h11.271a1.316,1.316,0,0,1,.966.4,1.316,1.316,0,0,1,.4.966v11.271a1.323,1.323,0,0,1-.4.958,1.3,1.3,0,0,1-.966.406Zm0-1.087H183.9a.272.272,0,0,0,.2-.078.272.272,0,0,0,.078-.2v-3.16h-2.819a3.621,3.621,0,0,1-1.239,1.558,3.075,3.075,0,0,1-1.838.6,3.181,3.181,0,0,1-1.868-.59,3.363,3.363,0,0,1-1.223-1.569h-2.838v3.16a.272.272,0,0,0,.078.2A.272.272,0,0,0,172.637-775.816Zm5.654-2.368a1.687,1.687,0,0,0,1.218-.5,2.825,2.825,0,0,0,.732-1.206.6.6,0,0,1,.325-.351,1.233,1.233,0,0,1,.513-.1h3.1v-7.019a.271.271,0,0,0-.078-.2.271.271,0,0,0-.2-.078H172.637a.271.271,0,0,0-.2.078.272.272,0,0,0-.078.2v7.019h3.109a1.232,1.232,0,0,1,.506.1.586.586,0,0,1,.324.351,2.769,2.769,0,0,0,.746,1.208A1.752,1.752,0,0,0,178.291-778.185Zm-5.654,2.368h0Z",
    transform: "translate(504.729 793.729)",
    fill: "#28ad56"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInboxCount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inboxCount.3c1038f8.svg";
export { ForwardRef as ReactComponent };